import { useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { TOASTER_TYPE } from '../constants/constants';

const useToast = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [toasterType, setToasterType] = useState(TOASTER_TYPE.SUCCESS);
  const [duration, setDuration] = useState(3000); // Default duration

  const showToast = useCallback((msg, type=TOASTER_TYPE.SUCCESS, time = 3000) => {
    setMessage(msg);
    setDuration(time);
    setOpen(true);
    setToasterType(type);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const Toast = () => (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={toasterType} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );

  return { showToast, Toast };
};

export default useToast;
